exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StripeElement[data-v-3ddcc9d4]{border:2px solid #aaa;border-radius:5px;padding:6px 14px;line-height:1.4}", ""]);

// exports
